import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { LocationApiAdapter } from '../adapters/LocationApiAdapter';
import { CreateLocationRequest, Location } from '../models/Location';
import { LocationService } from '../services/LocationService';

export const useCreateLocation = () => {
  const queryClient = useQueryClient();

  // 🎯 Memoizar instancias del servicio para evitar recrearlas en cada render
  const locationService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new LocationApiAdapter(httpClient);
    return new LocationService(apiAdapter);
  }, []);

  return useMutation<Location, Error, CreateLocationRequest>({
    mutationFn: (data: CreateLocationRequest) => locationService.createLocation(data),
    onSuccess: () => {
      // 🎯 Invalidar todas las queries de locations y racks para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['locations'] });
      queryClient.invalidateQueries({ queryKey: ['warehouse-racks'] });
    },
  });
};
